import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CommandBase, FilteredCommand, MultiselectCommand } from '../../../core/model/command';
import { ICommandHandler } from '../../../core/service/command/command-handler-resolver.service';
import { NativeWindowService } from '../../../core/service/native-window.service';
import { ContactService } from '../data/contact.service';

@Injectable()
export class ContactExportCommandHandler implements ICommandHandler {
  constructor(
    private _contactService: ContactService,
    private _nativeWindow: NativeWindowService
  ) {}

  canExecute(command: CommandBase): boolean {
    if (command instanceof MultiselectCommand) {
      return command.itemsSource.length > 0;
    }
    if (command instanceof FilteredCommand) {
      return command.filterProvider && command.totalAffectedItemsControlValue > 0;
    }
    return false;
  }

  execute(command: CommandBase): Observable<void> {
    if (command instanceof MultiselectCommand) {
      return this._contactService.export(command.items.map(item => item.id)).pipe(
        map(file => {
          this._nativeWindow.save(file);
        })
      );
    }
    if (command instanceof FilteredCommand) {
      return this._contactService
        .exportFilter(command.filterProvider.filterState, command.includedIds, command.excludedIds, command.totalAffectedItemsControlValue)
        .pipe(
          map(file => {
            this._nativeWindow.save(file);
          })
        );
    }
  }
}
